export const translations = {
  fr: {
    // Header
    header: {
      add: 'Ajouter',
      loading: 'Chargement...',
      loginYoutube: 'Connexion YouTube',
      loginShort: 'Connexion',
      points: 'pts',
    },
    // Home
    home: {
      voteHint: 'Aide ce youtubeur à trouver sa meilleure miniature · choisis la vidéo que tu regarderais',
      noMoreThumbnails: 'Plus aucune miniature à voter !',
      thanksForParticipating: 'Merci d\'avoir participé. Reviens plus tard pour de nouvelles miniatures.',
      unknownUser: 'Utilisateur inconnu',
      subscribers: 'abonnés',
    },
    // Profile
    profile: {
      youtubeSubscribers: 'Abonnés YouTube',
      batchesPublished: 'Lots publiés',
      batchPublished: 'Lot publié',
      guestAccount: 'Compte invité',
      signOut: 'Déconnexion',
      youtubeNotice: 'Pour ajouter des miniatures, connecte-toi avec un compte Google associé à une chaîne YouTube.',
      noBatchesYet: 'Aucun lot de miniatures publié pour le moment.',
      userNotFound: 'Utilisateur non trouvé',
      vote: 'vote',
      votes: 'votes',
      visitYoutubeChannel: 'Visiter la chaîne YouTube',
      feedStatsTitle: 'Performances sur l\'accueil',
      thumbnail: 'Miniature',
      impressions: 'Vues',
      clicks: 'Clics',
      ctr: 'CTR',
      winner: 'gagnante',
      themeAverage: 'Moyenne du thème :',
      noFeedData: 'Ce lot n\'a pas encore été affiché sur l\'accueil.',
      allVoted: 'Merci ! Tu as voté sur tous les lots de ce créateur. Voici les résultats.',
      batchColumn: 'Lot',
      themeColumn: 'Thème',
      bestCtr: 'Meilleur CTR',
      untitledBatch: 'Lot sans titre',
    },
    // Analyse IA des miniatures
    analysis: {
      title: 'Métriques image',
      run: 'Analyser avec l\'IA',
      rerun: 'Relancer l\'IA',
      running: 'Analyse...',
      error: 'L\'analyse a échoué. Réessaie dans un instant.',
      errorRateLimited: 'Trop d\'analyses d\'affilée. Attends une minute avant de relancer.',
      visualQuality: 'Qualité visuelle',
      clickability: 'Clickability',
      clickabilityDisclaimer: 'Estimation IA',
      pixelMetrics: 'Métriques image',
      brightness: 'Luminosité',
      contrast: 'Contraste',
      saturation: 'Saturation',
      curiosityGap: 'Curiosity gap',
      curiosityQuestions: 'Questions du viewer',
      strongerQuestion: 'Question plus forte',
      composition: 'Composition',
      faces: 'Visages',
      textLegibility: 'Lisibilité texte',
      focalPoint: 'Point focal',
      mobileReadability: 'Lisibilité mobile',
      tvReadability: 'Lisibilité TV',
      packagingOverlap: 'Chevauchement titre',
      packagingOverlapWarn: 'Le texte de ta miniature répète trop le titre',
      notApplicable: 'N/A',
      testerTitle: 'Tester une miniature',
      testerTitlePlaceholder: 'Titre de ta vidéo',
      testerUploadImage: 'Choisir une image',
      testerChangeImage: 'Changer l\'image',
      testerInvalidType: 'Format accepté : JPEG, PNG, GIF ou WebP',
      testerImageTooLarge: 'L\'image ne doit pas dépasser 5 Mo',
    },
    // Batch view
    batch: {
      backToProfile: '← Retour au profil',
      share: 'Partager',
      linkCopied: 'Lien copié !',
      cannotVoteOwn: 'Tu ne peux pas voter pour tes propres miniatures',
      voteHint: 'Aide ce youtubeur à trouver sa meilleure miniature · choisis la vidéo que tu regarderais',
      batchNotFound: 'Lot non trouvé',
    },
    // Add page
    add: {
      addTitle: 'Ajouter un titre',
      pageTitle: 'Ajouter une miniature',
      youtubeUrlLabel: 'URL de la vidéo YouTube (optionnel)',
      youtubeUrlPlaceholder: 'https://youtube.com/watch?v=... ou https://youtu.be/...',
      youtubeUrlError: 'Veuillez entrer une URL YouTube valide',
      themeLabel: 'Thème de la vidéo',
      themePlaceholder: 'Choisis un thème',
      themeHint: 'Tes miniatures ne seront affichées qu\'à côté de vidéos du même thème.',
      publishing: 'Envoi en cours...',
      publish: 'Ajouter la miniature',
      success: 'Les miniatures ont correctement été ajoutées',
      error: 'Une erreur s\'est produite empêchant l\'ajout des miniatures',
      minThumbnails: 'Ajoute au moins 2 miniatures pour publier.',
      loginRequired: 'Connexion requise',
      loginRequiredDesc: 'Tu dois te connecter pour ajouter des miniatures.',
      youtubeRequired: 'Chaîne YouTube requise',
      youtubeRequiredDesc: 'Pour ajouter des miniatures, tu dois te connecter avec un compte Google associé à une chaîne YouTube.',
      guestAccountHint: 'Ton compte actuel est un compte invité qui te permet uniquement de voter.',
      backToHome: 'Retour à l\'accueil',
    },
    // Feed (home)
    feed: {
      home: 'Accueil',
      emptyTheme: 'Aucune miniature à afficher dans ce thème pour le moment.',
      emptyHome: 'Aucune miniature publiée pour le moment.',
      hint: 'Clique sur la vidéo que tu regarderais',
      themesTitle: 'Thèmes',
      emptySearch: 'Aucun résultat pour cette recherche.',
      voteMode: 'Aider un créateur',
      moreActions: 'Plus d\'actions',
    },
    // Barre de recherche
    search: {
      placeholder: 'Rechercher',
      submit: 'Lancer la recherche',
      clear: 'Effacer la recherche',
    },
    // Aperçu d'une miniature dans le feed
    preview: {
      title: 'Aperçu sur le feed',
      hint: 'Choisis la miniature à tester : elle apparaît au milieu de vraies miniatures du même thème.',
      variants: 'Variantes du lot',
      notCounted: 'Cet aperçu ne compte ni vue ni clic : tes statistiques ne bougent pas.',
      back: '← Retour au profil',
      testOnFeed: 'Tester sur le feed',
      backToForm: '← Retour aux miniatures',
    },
    // Thèmes de vidéo (ids alignés sur src/constants/themes.ts)
    themes: {
      gaming: 'Gaming',
      tech: 'Informatique & Tech',
      sport: 'Sport',
      music: 'Musique',
      food: 'Cuisine',
      beauty: 'Beauté & Mode',
      comedy: 'Humour',
      news: 'Actualité',
      finance: 'Finance & Business',
      lifestyle: 'Vlogs & Lifestyle',
      entertainment: 'Divertissement',
      other: 'Autre',
    },
    // Errors
    errors: {
      generic: 'Une erreur est survenue',
      tooManyVotes: 'Trop de votes en peu de temps. Réessayez plus tard.',
    },
    // Footer
    footer: {
      description: 'pickthumb aide les créateurs YouTube à choisir la meilleure miniature à utiliser pour leur prochaine vidéo grâce aux votes de leur audience.',
      privacy: 'Politique de confidentialité',
      terms: 'Conditions d\'utilisation',
    },
    // Legal pages
    legal: {
      back: '← Retour',
      lastUpdated: 'Dernière mise à jour',
    },
    // Privacy page
    privacy: {
      title: 'Politique de confidentialité',
      intro: {
        title: '1. Introduction',
        text: 'Bienvenue sur pickthumb. Nous respectons votre vie privée et nous engageons à protéger vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations.',
      },
      dataCollected: {
        title: '2. Données collectées',
        intro: 'Lorsque vous utilisez pickthumb, nous collectons :',
        youtube: 'Informations de compte YouTube :',
        youtubeDesc: 'Nom de chaîne, identifiant YouTube, nombre d\'abonnés (via l\'API YouTube)',
        usage: 'Données d\'utilisation :',
        usageDesc: 'Miniatures créées, votes effectués',
        technical: 'Données techniques :',
        technicalDesc: 'Informations de connexion anonymisées pour améliorer le service',
      },
      dataUsage: {
        title: '3. Utilisation des données',
        intro: 'Vos données sont utilisées pour :',
        item1: 'Permettre la création et le partage de comparaisons de miniatures',
        item2: 'Afficher votre profil public avec vos créations',
        item3: 'Comptabiliser les votes sur les miniatures',
        item4: 'Améliorer nos services',
      },
      youtubeApi: {
        title: '4. API YouTube',
        text1: 'pickthumb utilise les services de l\'API YouTube. En utilisant notre service, vous acceptez également les',
        youtubeTerms: 'Conditions d\'utilisation de YouTube',
        and: 'et la',
        googlePrivacy: 'Politique de confidentialité de Google',
        text2: 'Nous accédons uniquement aux informations de base de votre chaîne YouTube (nom, identifiant, nombre d\'abonnés) avec votre consentement explicite lors de la connexion.',
      },
      dataSharing: {
        title: '5. Partage des données',
        intro: 'Nous ne vendons jamais vos données personnelles. Vos informations peuvent être partagées uniquement avec :',
        hosting: 'Services d\'hébergement :',
        hostingDesc: 'Pour stocker vos données de manière sécurisée (Supabase, Vercel)',
        google: 'API Google/YouTube :',
        googleDesc: 'Pour l\'authentification et la récupération des informations de chaîne',
      },
      security: {
        title: '6. Sécurité',
        text: 'Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données contre tout accès, modification, divulgation ou destruction non autorisés.',
      },
      rights: {
        title: '7. Vos droits',
        intro: 'Vous avez le droit de :',
        item1: 'Accéder à vos données personnelles',
        item2: 'Rectifier vos données',
        item3: 'Supprimer votre compte et vos données',
        item4: 'Révoquer l\'accès à votre compte YouTube à tout moment via les',
        googleSettings: 'paramètres de sécurité Google',
      },
      contact: {
        title: '8. Contact',
        text: 'Pour toute question concernant cette politique de confidentialité, vous pouvez nous contacter à',
      },
    },
    // Terms page
    terms: {
      title: 'Conditions d\'utilisation',
      acceptance: {
        title: '1. Acceptation des conditions',
        text: 'En accédant et en utilisant pickthumb, vous acceptez d\'être lié par ces conditions d\'utilisation. Si vous n\'acceptez pas ces conditions, veuillez ne pas utiliser notre service.',
      },
      description: {
        title: '2. Description du service',
        text: 'pickthumb est une plateforme permettant aux créateurs YouTube de comparer différentes miniatures pour leurs vidéos et de recueillir les votes de leur communauté afin de choisir la meilleure option.',
      },
      account: {
        title: '3. Compte utilisateur',
        intro: 'Pour utiliser certaines fonctionnalités de pickthumb, vous devez vous connecter avec votre compte Google/YouTube. Vous êtes responsable de :',
        item1: 'Maintenir la confidentialité de votre compte',
        item2: 'Toutes les activités effectuées sous votre compte',
        item3: 'Nous informer immédiatement de toute utilisation non autorisée',
      },
      acceptableUse: {
        title: '4. Utilisation acceptable',
        intro: 'En utilisant pickthumb, vous vous engagez à ne pas :',
        item1: 'Publier du contenu illégal, offensant ou portant atteinte aux droits d\'autrui',
        item2: 'Utiliser le service à des fins frauduleuses',
        item3: 'Tenter de contourner les mesures de sécurité',
        item4: 'Manipuler artificiellement les votes',
        item5: 'Collecter les données d\'autres utilisateurs sans autorisation',
      },
      userContent: {
        title: '5. Contenu utilisateur',
        text1: 'Vous conservez tous les droits sur le contenu que vous publiez (miniatures, images). En publiant du contenu sur pickthumb, vous nous accordez une licence non exclusive pour afficher ce contenu dans le cadre du fonctionnement du service.',
        text2: 'Vous êtes seul responsable du contenu que vous publiez et garantissez détenir les droits nécessaires sur ce contenu.',
      },
      thirdParty: {
        title: '6. Services tiers',
        intro: 'pickthumb utilise les services de l\'API YouTube. En utilisant notre service, vous acceptez également :',
        youtubeTerms: 'Les Conditions d\'utilisation de YouTube',
        googlePrivacy: 'La Politique de confidentialité de Google',
      },
      liability: {
        title: '7. Limitation de responsabilité',
        text: 'pickthumb est fourni "tel quel" sans garantie d\'aucune sorte. Nous ne sommes pas responsables des dommages directs ou indirects résultant de l\'utilisation ou de l\'impossibilité d\'utiliser le service.',
      },
      modifications: {
        title: '8. Modifications',
        text: 'Nous nous réservons le droit de modifier ces conditions à tout moment. Les modifications entrent en vigueur dès leur publication. Votre utilisation continue du service après modification constitue votre acceptation des nouvelles conditions.',
      },
      termination: {
        title: '9. Résiliation',
        text: 'Nous pouvons suspendre ou résilier votre accès au service à tout moment, sans préavis, en cas de violation de ces conditions d\'utilisation.',
      },
      contact: {
        title: '10. Contact',
        text: 'Pour toute question concernant ces conditions d\'utilisation, contactez-nous à',
      },
    },
  },
  en: {
    // Header
    header: {
      add: 'Add',
      loading: 'Loading...',
      loginYoutube: 'YouTube Login',
      loginShort: 'Login',
      points: 'pts',
    },
    // Home
    home: {
      voteHint: 'Help this YouTuber find its best thumbnail. Choose the video you would watch',
      noMoreThumbnails: 'No more thumbnails to vote on!',
      thanksForParticipating: 'Thanks for participating. Come back later for new thumbnails.',
      unknownUser: 'Unknown user',
      subscribers: 'subscribers',
    },
    // Profile
    profile: {
      youtubeSubscribers: 'YouTube Subscribers',
      batchesPublished: 'Batches published',
      batchPublished: 'Batch published',
      guestAccount: 'Guest account',
      signOut: 'Sign out',
      youtubeNotice: 'To add thumbnails, sign in with a Google account linked to a YouTube channel.',
      noBatchesYet: 'No thumbnail batches published yet.',
      userNotFound: 'User not found',
      vote: 'vote',
      votes: 'votes',
      visitYoutubeChannel: 'Visit YouTube channel',
      feedStatsTitle: 'Home feed performance',
      thumbnail: 'Thumbnail',
      impressions: 'Views',
      clicks: 'Clicks',
      ctr: 'CTR',
      winner: 'winner',
      themeAverage: 'Theme average:',
      noFeedData: 'This batch has not been shown on the home feed yet.',
      allVoted: 'Thanks! You voted on every batch from this creator. Here are the results.',
      batchColumn: 'Batch',
      themeColumn: 'Theme',
      bestCtr: 'Best CTR',
      untitledBatch: 'Untitled batch',
    },
    // AI thumbnail analysis
    analysis: {
      title: 'Image metrics',
      run: 'Analyse with AI',
      rerun: 'Rerun AI',
      running: 'Analysing...',
      error: 'The analysis failed. Try again in a moment.',
      errorRateLimited: 'Too many analyses in a row. Wait a minute before running it again.',
      visualQuality: 'Visual quality',
      clickability: 'Clickability',
      clickabilityDisclaimer: 'AI estimate',
      pixelMetrics: 'Image metrics',
      brightness: 'Brightness',
      contrast: 'Contrast',
      saturation: 'Saturation',
      curiosityGap: 'Curiosity gap',
      curiosityQuestions: 'Viewer questions',
      strongerQuestion: 'Stronger question',
      composition: 'Composition',
      faces: 'Faces',
      textLegibility: 'Text legibility',
      focalPoint: 'Focal point',
      mobileReadability: 'Mobile readability',
      tvReadability: 'TV readability',
      packagingOverlap: 'Title overlap',
      packagingOverlapWarn: 'Your thumbnail text repeats too much of the title',
      notApplicable: 'N/A',
      testerTitle: 'Test a thumbnail',
      testerTitlePlaceholder: 'Your video title',
      testerUploadImage: 'Choose an image',
      testerChangeImage: 'Change image',
      testerInvalidType: 'Accepted formats: JPEG, PNG, GIF or WebP',
      testerImageTooLarge: 'Image must be under 5 MB',
    },
    // Batch view
    batch: {
      backToProfile: '← Back to profile',
      share: 'Share',
      linkCopied: 'Link copied!',
      cannotVoteOwn: 'You cannot vote on your own thumbnails',
      voteHint: 'Help this YouTuber find their best thumbnail. Choose the video you would watch',
      batchNotFound: 'Batch not found',
    },
    // Add page
    add: {
      addTitle: 'Add a title',
      pageTitle: 'Add a thumbnail',
      youtubeUrlLabel: 'YouTube video URL (optional)',
      youtubeUrlPlaceholder: 'https://youtube.com/watch?v=... or https://youtu.be/...',
      youtubeUrlError: 'Please enter a valid YouTube URL',
      themeLabel: 'Video theme',
      themePlaceholder: 'Pick a theme',
      themeHint: 'Your thumbnails will only be shown next to videos from the same theme.',
      publishing: 'Uploading...',
      publish: 'Add thumbnail',
      success: 'Thumbnails have been successfully added',
      error: 'An error occurred while adding thumbnails',
      minThumbnails: 'Add at least 2 thumbnails to publish.',
      loginRequired: 'Login required',
      loginRequiredDesc: 'You must sign in to add thumbnails.',
      youtubeRequired: 'YouTube channel required',
      youtubeRequiredDesc: 'To add thumbnails, you need to sign in with a Google account linked to a YouTube channel.',
      guestAccountHint: 'Your current account is a guest account that only allows voting.',
      backToHome: 'Back to home',
    },
    // Feed (home)
    feed: {
      home: 'Home',
      emptyTheme: 'No thumbnails to show in this theme yet.',
      emptyHome: 'No thumbnails published yet.',
      hint: 'Click the video you would actually watch',
      themesTitle: 'Themes',
      emptySearch: 'No results for this search.',
      voteMode: 'Help a creator',
      moreActions: 'More actions',
    },
    // Search bar
    search: {
      placeholder: 'Search',
      submit: 'Search',
      clear: 'Clear search',
    },
    // Feed preview for a thumbnail
    preview: {
      title: 'Feed preview',
      hint: 'Pick the thumbnail to test: it appears among real thumbnails from the same theme.',
      variants: 'Batch variants',
      notCounted: 'This preview counts no view and no click: your stats stay untouched.',
      back: '← Back to profile',
      testOnFeed: 'Test on the feed',
      backToForm: '← Back to thumbnails',
    },
    // Video themes (ids kept in sync with src/constants/themes.ts)
    themes: {
      gaming: 'Gaming',
      tech: 'Tech & Computing',
      sport: 'Sports',
      music: 'Music',
      food: 'Food',
      beauty: 'Beauty & Fashion',
      comedy: 'Comedy',
      news: 'News',
      finance: 'Finance & Business',
      lifestyle: 'Vlogs & Lifestyle',
      entertainment: 'Entertainment',
      other: 'Other',
    },
    // Errors
    errors: {
      generic: 'An error occurred',
      tooManyVotes: 'Too many votes in a short time. Please try again later.',
    },
    // Footer
    footer: {
      description: 'pickthumb helps YouTube creators choose the best thumbnail for their next video through audience votes.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
    },
    // Legal pages
    legal: {
      back: '← Back',
      lastUpdated: 'Last updated',
    },
    // Privacy page
    privacy: {
      title: 'Privacy Policy',
      intro: {
        title: '1. Introduction',
        text: 'Welcome to pickthumb. We respect your privacy and are committed to protecting your personal data. This privacy policy explains how we collect, use, and protect your information.',
      },
      dataCollected: {
        title: '2. Data Collected',
        intro: 'When you use pickthumb, we collect:',
        youtube: 'YouTube account information:',
        youtubeDesc: 'Channel name, YouTube ID, subscriber count (via YouTube API)',
        usage: 'Usage data:',
        usageDesc: 'Thumbnails created, votes cast',
        technical: 'Technical data:',
        technicalDesc: 'Anonymized connection information to improve the service',
      },
      dataUsage: {
        title: '3. Data Usage',
        intro: 'Your data is used to:',
        item1: 'Enable the creation and sharing of thumbnail comparisons',
        item2: 'Display your public profile with your creations',
        item3: 'Count votes on thumbnails',
        item4: 'Improve our services',
      },
      youtubeApi: {
        title: '4. YouTube API',
        text1: 'pickthumb uses YouTube API services. By using our service, you also agree to the',
        youtubeTerms: 'YouTube Terms of Service',
        and: 'and the',
        googlePrivacy: 'Google Privacy Policy',
        text2: 'We only access basic information from your YouTube channel (name, ID, subscriber count) with your explicit consent during sign-in.',
      },
      dataSharing: {
        title: '5. Data Sharing',
        intro: 'We never sell your personal data. Your information may only be shared with:',
        hosting: 'Hosting services:',
        hostingDesc: 'To store your data securely (Supabase, Vercel)',
        google: 'Google/YouTube API:',
        googleDesc: 'For authentication and channel information retrieval',
      },
      security: {
        title: '6. Security',
        text: 'We implement appropriate security measures to protect your data against unauthorized access, modification, disclosure, or destruction.',
      },
      rights: {
        title: '7. Your Rights',
        intro: 'You have the right to:',
        item1: 'Access your personal data',
        item2: 'Correct your data',
        item3: 'Delete your account and data',
        item4: 'Revoke access to your YouTube account at any time via',
        googleSettings: 'Google security settings',
      },
      contact: {
        title: '8. Contact',
        text: 'For any questions regarding this privacy policy, you can contact us at',
      },
    },
    // Terms page
    terms: {
      title: 'Terms of Service',
      acceptance: {
        title: '1. Acceptance of Terms',
        text: 'By accessing and using pickthumb, you agree to be bound by these terms of service. If you do not accept these terms, please do not use our service.',
      },
      description: {
        title: '2. Service Description',
        text: 'pickthumb is a platform that allows YouTube creators to compare different thumbnails for their videos and gather community votes to choose the best option.',
      },
      account: {
        title: '3. User Account',
        intro: 'To use certain features of pickthumb, you must sign in with your Google/YouTube account. You are responsible for:',
        item1: 'Maintaining the confidentiality of your account',
        item2: 'All activities performed under your account',
        item3: 'Notifying us immediately of any unauthorized use',
      },
      acceptableUse: {
        title: '4. Acceptable Use',
        intro: 'By using pickthumb, you agree not to:',
        item1: 'Post illegal, offensive content or content that infringes on the rights of others',
        item2: 'Use the service for fraudulent purposes',
        item3: 'Attempt to bypass security measures',
        item4: 'Artificially manipulate votes',
        item5: 'Collect data from other users without authorization',
      },
      userContent: {
        title: '5. User Content',
        text1: 'You retain all rights to the content you post (thumbnails, images). By posting content on pickthumb, you grant us a non-exclusive license to display this content as part of the service operation.',
        text2: 'You are solely responsible for the content you post and warrant that you hold the necessary rights to this content.',
      },
      thirdParty: {
        title: '6. Third-Party Services',
        intro: 'pickthumb uses YouTube API services. By using our service, you also agree to:',
        youtubeTerms: 'YouTube Terms of Service',
        googlePrivacy: 'Google Privacy Policy',
      },
      liability: {
        title: '7. Limitation of Liability',
        text: 'pickthumb is provided "as is" without warranty of any kind. We are not liable for any direct or indirect damages resulting from the use or inability to use the service.',
      },
      modifications: {
        title: '8. Modifications',
        text: 'We reserve the right to modify these terms at any time. Modifications take effect upon publication. Your continued use of the service after modification constitutes your acceptance of the new terms.',
      },
      termination: {
        title: '9. Termination',
        text: 'We may suspend or terminate your access to the service at any time, without notice, in case of violation of these terms of service.',
      },
      contact: {
        title: '10. Contact',
        text: 'For any questions regarding these terms of service, contact us at',
      },
    },
  },
} as const;

export type Language = keyof typeof translations;

// Create a type that maps the structure but with string values
type DeepStringify<T> = {
  [K in keyof T]: T[K] extends object ? DeepStringify<T[K]> : string;
};

export type TranslationKeys = DeepStringify<typeof translations.fr>;
